import React from 'react';
import Certain from "../../../../components/Operation/Certain";
import Delay from "../../../../components/Operation/Delay";
import Duration from "../../../../components/Operation/Duration";
import ExternalSite from "../../../../components/Operation/ExternalSite";
import FishDisease from "../../../../components/Operation/FishDisease";
import Id from "../../../../components/Operation/Id";
import LiceList from "../../../../components/Operation/LiceList";
import Logo from "../../../../components/Operation/Logo";
import NameSpot from "../../../../components/Operation/NameSpot";
import Note from "../../../../components/Operation/Note";
import NoteDetail from "../../../../components/Operation/NoteDetail";
import OperationStatus from "../../../../components/Operation/OperationStatus";
import SumWeight from "../../../../components/Operation/SumWeight";
import Weather from "../../../../components/Operation/Weather";
import { OP_STATUS, OPERATION_TYPE, SITE_TYPE } from "../../../../util/varibles/constants";
import { IOperation, TOperation2 } from "../../../../util/varibles/interface";
import styles from "./style.module.scss";

interface IProps {
    data: IOperation
    isOwn: boolean
    status: OP_STATUS
}

const TransportView: React.FC<IProps> = ({ data, isOwn, status }) => {
    const { operation, vessel, activity_log } = data;

    return <>
        <div className={styles.title}>
            <div className={styles.left}>
                <Logo type={OPERATION_TYPE.TRANSPORT} status={status} />
                <Id {...{ visible: true, operation, status }} />
                <OperationStatus {...{ status, }} />
                <Certain {...{ operation, status }} />
                <div className='flex'>
                    <div className={styles['site-unit']}>{operation.source_name}</div>
                    <span className='arrow-right' />
                    <div className={styles.factory}>{operation.destination_name}</div>
                </div>
            </div>
            <div className={styles.right}>
                <Delay visible={true} operation={operation} />
                <Note {...{ visible: true, operation }} />
                <ExternalSite {...{
                    visible: true,
                    operation,
                    type: operation.source_site_type === SITE_TYPE.EXTERNAL || operation.destination_site_type === SITE_TYPE.EXTERNAL
                }} />
                <Weather {...{ visible: true, operation: operation as TOperation2 }} />
                {!isOwn && <NameSpot {...{ visible: true, operation }} />}
            </div>
        </div>
        <FishDisease diseases={operation.diseases} units={operation.sub_operations} wrapperClass={styles.section} />
        <LiceList diseases={operation.diseases} count={operation.sites?.length} short wrapperClass={styles.section} />
        <div className={styles.section}>
            <SumWeight{...{
                visible: true,
                className: styles['sum-weight'],
                operation,
                vessel,
                isLabel: false
            }} />
        </div>
        <div className={styles.section}>
            <Duration {...{ status, activity_log }} />
        </div>
        <NoteDetail operation={operation} visible={true} />
    </>;
};

export default TransportView;
